import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  CameraOutlined,
  FileImageOutlined,
  ArrowRightOutlined,
  SplitCellsOutlined,
} from "@ant-design/icons";
import StatusTag from "../../Common/StatustTag";
import { Button } from "antd";

const DATE_FORMAT = "DD/MM/YYYY hh:mm a";

export const genColumns = ({ showVideo, setCurrentVideo, setSplitOpen }) =>
  [
    {
      title: "ID",
      dataIndex: "id",
      width: 140,
    },

    {
      title: "# Multa",
      width: 30,
      dataIndex: "fine",
      render: (fine) => fine?.correlative_gtu,
      hidden: !window.location.search,
    },
    {
      title: "Estado",
      width: 30,
      dataIndex: "status_name",
      render: (status_name, record) => <StatusTag status={record.status} />,
      hidden: !window.location.search,
    },
    {
      title: "Desde",
      dataIndex: "upload_origin",
      render: (value) => (
        <span>
          {value === "camera" || value === "LP" ? (
            <CameraOutlined style={{ color: "#00bcd4" }} />
          ) : (
            <FileImageOutlined style={{ color: "#FF9800" }} />
          )}{" "}
          {value === "camera"
            ? "Cámara"
            : value === "gallery"
            ? "Galería"
            : value}
        </span>
      ),
      width: 100,
    },
    {
      title: "Subida",
      dataIndex: "device_creation_date",
      render: (value) => moment(value).fromNow(),
    },
    {
      width: 180,
      title: "F.Grabación",
      dataIndex: "device_creation_date",
      sorter: true,
      render: (value) => moment(value).format(DATE_FORMAT),
    },
    {
      title: "Placa",
      dataIndex: "vehicle_plate",
      render: (value) => <Link to={"/videos?search=" + value}>{value}</Link>,
    },

    {
      title: "Distrito",
      key: "municipality",
      dataIndex: "municipality",
    },

    {
      title: "Categoría",
      dataIndex: "infringement",
    },
    {
      title: "Preview",
      dataIndex: "cover_url_cdn",
      render: (value) =>
        value ? <img alt="preview" className="img-preview" src={value} /> : "-",
    },
    {
      title: "Atender",
      key: "attend",
      align: "right",
      fixed: "right",
      width: 100,
      render: (value, record) => (
        <div style={{ gap: 5, display: "flex" }}>
          {!record.parent_id ? (
            <Button
              onClick={() => {
                setCurrentVideo(record);
                setSplitOpen(true, record);
              }}
              ghost
              style={{ borderColor: "#d741ff" }}
              icon={<SplitCellsOutlined />}
            ></Button>
          ) : null}

          {record.status == 1 ? (
            <Button
              onClick={() => showVideo(record)}
              style={{ borderColor: "#00BCD4" }}
            >
              {record.in_use_at ? "Atendiendo" : "Atender"}
            </Button>
          ) : (
            <Link to={"/videos/" + record.id}>
              <Button
                type="ghost"
                style={{ borderColor: "#67d233", background: "#80b268" }}
                icon={<ArrowRightOutlined />}
              >
                Atendido
              </Button>
            </Link>
          )}
        </div>
      ),
    },
  ].filter((item) => !item.hidden);
